import { apiGet, apiPatch } from '../../../shared/api-client/index.js';

export interface DashboardScenarioRunSignal {
  id: string;
  status: string;
  scenarioId: string;
  createdAt: string;
  finishedAt: string | null;
}

export interface DashboardPendingApprovalSignal {
  id: string;
  status: string;
  kind: string;
  createdAt: string;
  expiresAt: string | null;
}

export interface DashboardSignals {
  scenarioRuns: DashboardScenarioRunSignal[];
  pendingApprovals: DashboardPendingApprovalSignal[];
}

export interface DashboardStats {
  dealsTotal: number;
  wonThisMonth: number;
  hotLeadsCount: number;
  avgDealValue: number;
}

export interface DashboardActivity {
  id: string;
  kind: string;
  actor: string;
  subject: string | null;
  occurredAt: string;
  payload: Record<string, unknown>;
  deal: { id: string; title: string } | null;
  contact: { id: string; firstName: string; lastName: string | null } | null;
}

export interface DashboardOnboardingState {
  id: string;
  userId: string;
  workspaceId: string;
  completedSteps: string[];
  dismissed: boolean;
  updatedAt: string;
}

export function getDashboardSignalsQueryKey(workspaceId: string): readonly [string, string, string] {
  return ['dashboard', workspaceId, 'signals'] as const;
}

export async function getDashboardSignals(): Promise<DashboardSignals> {
  return apiGet<DashboardSignals>('/dashboard/signals');
}

export function getDashboardStatsQueryKey(workspaceId: string): readonly [string, string, string] {
  return ['dashboard', workspaceId, 'stats'] as const;
}

export async function getDashboardStats(): Promise<DashboardStats> {
  return apiGet<DashboardStats>('/dashboard/stats');
}

export function getDashboardActivityQueryKey(workspaceId: string): readonly [string, string, string] {
  return ['dashboard', workspaceId, 'activity'] as const;
}

export async function getDashboardActivity(limit: number = 10): Promise<DashboardActivity[]> {
  return apiGet<DashboardActivity[]>(`/dashboard/activity?limit=${limit}`);
}

export function getDashboardOnboardingQueryKey(workspaceId: string): readonly [string, string, string] {
  return ['dashboard', workspaceId, 'onboarding'] as const;
}

export async function getDashboardOnboarding(): Promise<DashboardOnboardingState> {
  return apiGet<DashboardOnboardingState>('/dashboard/onboarding');
}

export async function updateDashboardOnboarding(data: { completedSteps?: string[], dismissed?: boolean }): Promise<DashboardOnboardingState> {
  return apiPatch<DashboardOnboardingState>('/dashboard/onboarding', { body: data });
}
